<template>
  <v-container fluid fill-height>
    <v-toolbar :color="expertColor" dark app fixed flat>
      <v-toolbar-title style="width: 300px;" class="ml-5 pl-3">
        <a :href="`${webUrl}`" target="_blank">
          <img src="@/assets/logo.png" style="width: 100px; height: 70px;" alt>
        </a>
      </v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>
    <v-layout align-center justify-center class="top-margin">
      <v-flex xs12 sm8 md7 lg6>
        <v-card class="elevation-12">
          <v-toolbar dark :color="toolbarColor">
            <v-toolbar-title class="display-small" v-if="accountType == 'An Expert'">Create {{accountType}} (Service Provider) Account</v-toolbar-title>
            <v-toolbar-title class="display-small" v-else-if="accountType == 'A Sonko'">Create {{accountType}} (Employer) Account</v-toolbar-title>
            <v-toolbar-title class="display-small" v-else-if="accountType == 'A VIP Sonko'">Create {{accountType}} (Employer) Account</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-card-text>
            <v-form>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12 sm12 v-if="accountType == 'A VIP Sonko'">
                    <center><v-btn color="red" flat @click="showPaidModal()">Benefits of the Paid VIP Plans</v-btn></center>
                  </v-flex>
                  <v-flex xs12 sm6>
                    <v-text-field
                      v-validate="'required'"
                      :error-messages="errors.collect('firstName')"
                      data-vv-name="firstName"
                      v-model="firstName"
                      label="First Name"
                      type="text"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6>
                    <v-text-field
                      v-validate="'required'"
                      :error-messages="errors.collect('lastName')"
                      data-vv-name="lastName"
                      v-model="lastName"
                      label="Last Name"
                      type="text"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 md6>
                    <v-autocomplete
                      v-validate="'required'"
                      :error-messages="errors.collect('countryCode')"
                      data-vv-name="countryCode"
                      :items="countryCodes"
                      v-model="countryCode"
                      label="Phone No Country Code"
                      single-line
                      item-text="text"
                      item-value="text"
                      required
                    ></v-autocomplete>
                    
                  </v-flex>
                  <v-flex xs12 md6>
                    <v-text-field
                      v-validate="'required'"
                      :error-messages="errors.collect('phone')"
                      data-vv-name="phone"
                      v-model="phone"
                      label="Rest of the No: eg 712345678"
                      type="text"
                    ></v-text-field>
                    <span style="color: red">{{phone_msg}}</span>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field v-validate="'required|email'" :error-messages="errors.collect('email')" data-vv-name="email" v-model="email" label="Email" type="text"></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6>
                    <v-text-field
                      v-validate="'required'"
                      :error-messages="errors.collect('password')"
                      data-vv-name="password"
                      v-model="password"
                      label="Password"
                      type="password"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6>
                    <v-text-field
                      v-validate="'required'"
                      :error-messages="errors.collect('confirmPassword')"
                      data-vv-name="confirmPassword"
                      v-model="confirmPassword"
                      label="Confirm Password"
                      type="password"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12>
                    <span style="color: red">{{err_msg}}</span>
                  </v-flex>
                  <v-flex xs12 sm12>
                    <v-checkbox v-model="checkbox" >
                      <template v-slot:label>
                        <div>
                          I agree to the 
                          <a target="_blank" href="https://ewak.co.ke/terms">
                              Terms and Conditions
                          </a>
                        </div>
                      </template>
                    </v-checkbox>
                  </v-flex>
                  <v-flex xs12 sm12>
                    <span class="v-messages error--text">{{agree_err_msg}}</span>
                  </v-flex>
                  <v-flex xs12 sm6>
                    <v-btn :color="toolbarColor" @click="save" dark>Submit</v-btn>
                  </v-flex>
                  <v-flex xs12 sm6>
                    Already a Member.
                    <v-btn flat color="primary" :to="`/login/${userAccount}/normal`">Login</v-btn>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-form>
          </v-card-text>

          <!-- Paid plan popup -->
          <v-dialog v-model="paidPlanDialog" max-width="750px">
            <v-toolbar flat dense color="primary" dark>
              <v-toolbar-title class="title">Benefits of the Paid VIP Plans</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn icon class="mx-0" @click.native="paidPlanDialog = false">
                <v-icon color="white">clear</v-icon>
              </v-btn>
            </v-toolbar>
            <v-card>
              <v-card-text>
                <v-container grid-list-md>
                  <v-layout wrap>
                    <v-flex xs12>
                      <ul>
                        <li>Your posted jobs are listed first/top of the list. </li>
                        <li>You can choose additional preferred job locations to alert more experts per job post for fatser bids.</li>
                        <li>You get flexible dedicated support timelines with jobs posting & the bidding process.</li>
                        <li>You get recommendations of reliable experts among other benefits.</li>
                      </ul>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>
            </v-card>
          </v-dialog>
          <!-- End -->

        </v-card>
      </v-flex>

      <!--  snackbar -->
      <app-snackbar ref="snackbar"></app-snackbar>
      <!-- end -->
    </v-layout>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import { countryCodes } from "@/common/methods.js";

export default {
  name: "FundiLoginPage",
  components: {},
  computed: {
    ...mapGetters(["webUrl"])
  },
  data() {
    return {
      expertColor: "white",
      toolbarColor: null,
      userAccount: null,
      accountType: null,
      firstName: null,
      lastName: null,
      phone: null,
      email: null,
      password: null,
      confirmPassword: null,
      role: null,
      err_msg: null,
      countryCode: null,
      countryCodes: countryCodes(),
      phone_msg: null,
      checkbox: false,
      agree_err_msg: null,
      paidPlanDialog: false,
      metaTitle: '',
      metaDescription: ''
    };
  },
  metaInfo() {
    return {
      title: this.metaTitle,
      meta: [
        { vmid: 'description', name: 'description', content: this.metaDescription}
      ]
    }
  },
  methods: {
    navigateHome() {
      window.location = this.webUrl;
    },
    validMail(mail) {
      return /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()\.,;\s@\"]+\.{0,1})+([^<>()\.,;:\s@\"]{2,}|[\d\.]+))$/.test(
        mail
      );
    },
    save() {
      // validation
      this.$validator.validateAll().then(isValid => {
        if(this.checkbox == false) {
          this.agree_err_msg = "Please agree to Terms and Conditions!";
        } else {
          this.agree_err_msg = '';
        }
        if (isValid && this.checkbox == true) {
          // pass check
          if(this.phone.startsWith('0')) {
            this.phone_msg = "If your Country Code is correct, do not start with ‘0’";
          } else if(!/^[0-9]+$/.test(this.phone)) {
            this.phone_msg = "Phone no should be Numerals only...";
          } else if (this.password !== this.confirmPassword) {
            this.phone_msg = null;
            this.err_msg = "Passwords Don't match!";
          } else {
            // test mail
            if (this.email !== null) {
              const mailTest = this.validMail(this.email);
              // check mail
              if (mailTest == false) {
                this.$refs.snackbar.show("Please put a correct email address!", "red");
              } else {
                // save
                const data = {
                  firstName: this.firstName,
                  lastName: this.lastName,
                  phone: this.phone,
                  email: this.email,
                  password: this.password,
                  accountType: this.role,
                  role: this.role,
                  countryCode: this.countryCode
                };

                this.loading = true;
                const self = this;
                const res = this.$store
                  .dispatch("post", { url: "/user/register", data })
                  .then(res => {
                    self.loading = false;
                    if (res.state == true) {
                      localStorage.setItem("subscription", "noSubs");
                      localStorage.setItem("token", res.token);
                      self.$store.commit("setUser", res.user);
                      // start otp verification
                      if (res.user.accountType == "sonko") {
                        this.$router.push(`/sonko/profile`);
                      } else if (res.user.accountType == "expert") {
                        this.$router.push(`/expert/profile`);
                      } else if (res.user.accountType == "vip_sonko") {
                        this.$router.push(`/vip_sonko/profile`);
                      } else {
                        this.$router.push(`/dashboard`);
                      }

                      // end of otp verification
                    } else {
                      this.err_msg = res.err;
                    }
                  })
                  .finally(() => {});
              }
            } else {
              // save
              const data = {
                firstName: this.firstName,
                lastName: this.lastName,
                phone: this.phone,
                email: this.email,
                password: this.password,
                accountType: this.role,
                role: this.role,
                countryCode: this.countryCode
              };

              this.loading = true;
              const self = this;
              const res = this.$store
                .dispatch("post", { url: "/user/register", data })
                .then(res => {
                  self.loading = false;
                  if (res.state == true) {
                    localStorage.setItem("subscription", "noSubs");
                    localStorage.setItem("token", res.token);
                    self.$store.commit("setUser", res.user);
                    // start otp verification
                    if (res.user.accountType == "sonko") {
                      this.$router.push(`/sonko/profile`);
                    } else if (res.user.accountType == "expert") {
                      this.$router.push(`/expert/profile`);
                    } else if (res.user.accountType == "vip_sonko") {
                        this.$router.push(`/vip_sonko/profile`);
                    } else {
                      this.$router.push(`/dashboard`);
                    }

                    // end of otp verification
                  } else {
                    this.err_msg = res.err;
                  }
                })
                .finally(() => {});
              // end of save
            }

            // end of mail test

            // close pass check
          }
        }
      });
      //end of validation
    },
    showPaidModal() {
      this.paidPlanDialog = true;
    }
  },
  created() {
    const account = this.$route.params.status;
    this.userAccount = account;
    if (account == "expert") {
      this.accountType = "An Expert";
      this.role = "expert";
      this.toolbarColor = "blue darken-1";
      this.metaTitle = "Create an Expert Account Profile & Portfolio";
      this.metaDescription = "With an online work profile, you are able to get engaged by consumers who see your profile and skills. You are also able to post jobs and market your expertise.";
    } else if (account == "sonko") {
      this.accountType = "A Sonko";
      this.role = "sonko";
      this.toolbarColor = "green darken-1";
      this.metaTitle = "Post a Job - Register a Standard Sonko/Employer Account";
      this.metaDescription = "Create an account to access expert profiles and filter them by skills and then post a job and the experts will be notified and bid for the same. You get alerted by email when bids are placed on the job. ";
    } else if (account == "vip_sonko") {
      this.accountType = "A VIP Sonko";
      this.role = "vip_sonko";
      this.toolbarColor = "green darken-1";
      this.metaTitle = "Register a VIP Employer/Sonko Account";
      this.metaDescription = "With a VIP Sonko account, you get to enjoy dedicate support in acquiring experts and job bidding and assignment among other user benefits. ";
    }
  }
};
</script>
<style scoped>
.top-margin {
  margin-top: 50px;
}
@media (max-width: 420px) {
  .display-small {
    font-size: 12px;
  }
}
@media only screen and (max-width: 599px) {
  .top-margin {
    margin-top: 100px;
  }
}
@media (min-width: 420px) and (max-width: 776px) {
  .display-small {
    font-size: 14px;
  }
}
</style>


